export enum Permissions {
  // Filters
  SHOW_RSA_FILTER = 'SHOW_RSA_FILTER',
  SHOW_ISR_FILTER = 'SHOW_ISR_FILTER',
  SHOW_DEALER_FILTER = 'SHOW_DEALER_FILTER',

  // DEFAULT Filters
  DEFAULT_TO_RSA_FILTER = 'DEFAULT_TO_RSA_FILTER',
  DEFAULT_TO_ISR_FILTER = 'DEFAULT_TO_ISR_FILTER',
  DEFAULT_TO_DEALER_FILTER = 'DEFAULT_TO_DEALER_FILTER',

  // Columns
  SHOW_RSA_COLUMN = 'SHOW_RSA_COLUMN',
  SHOW_ISR_COLUMN = 'SHOW_ISR_COLUMN',
  SHOW_DEALER_COLUMN = 'SHOW_DEALER_COLUMN',

  // Order
  CAN_ADD_ORDER = 'CAN_ADD_ORDER',
  CAN_MODIFY_ORDER = 'CAN_MODIFY_ORDER',
  CAN_DELETE_ORDER = 'CAN_DELETE_ORDER',
  SHOW_ORDER_ADMIN_TAB = 'SHOW_ORDER_ADMIN_TAB',

  // Transfers
  CAN_ADD_NEW_TRANSFER = 'CAN_ADD_NEW_TRANSFER',
  CAN_MODIFY_TRANSFER = 'CAN_MODIFY_TRANSFER',

  // Products
  CAN_MODIFY_PRODUCT = 'CAN_MODIFY_PRODUCT',
}
